import { FastField, Field } from 'formik';

export const CustomField = ({ fastField, children, ...rest }) => {
  return fastField ? <FastField {...rest}>{children}</FastField> : <Field {...rest}>{children}</Field>;
};
